import { Text, VStack } from '@ayble-health/dashboard-components';
import { Flex } from '@chakra-ui/react';
import { FlaskConical, HelpCircle } from 'lucide-react';
import { useToken } from '@chakra-ui/react';
import React, { useMemo } from 'react';
import { SideNavLocation } from './types';
import { CareSVG, HomeSVG } from '../CustomSVGs';
import styled from '@emotion/styled';

const Wrapper = styled('div')<{ disabled: boolean }>`
  margin: 12px 0;

  &:hover {
    cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  }
`;

type Props = {
  disabled?: boolean;
  isSelected: boolean;
  location: SideNavLocation;
  onLocationSelect: (location: SideNavLocation) => void;
};

const computeLocationIconMap: (
  color: string
) => Record<SideNavLocation, React.JSX.Element> = (color: string) => ({
  [SideNavLocation.Care]: <CareSVG stroke={color} />,
  [SideNavLocation.Home]: (
    <Flex alignItems={'center'} boxSize={'32px'}>
      <HomeSVG stroke={color} />
    </Flex>
  ),
  [SideNavLocation.Support]: <HelpCircle color={color} size={24} />,
  [SideNavLocation.Labs]: <FlaskConical color={color} size={24} />,
});

export const SideNavButton = ({
  disabled = false,
  location,
  isSelected,
  onLocationSelect,
}: Props) => {
  const [primary400] = useToken('colors', ['primary.400']);
  const buttonIcon = useMemo(
    () => computeLocationIconMap(isSelected ? primary400 : 'white'),
    [primary400, isSelected]
  )[location];

  return (
    <Wrapper
      disabled={disabled}
      onClick={() => {
        if (disabled) return;

        onLocationSelect(location);
      }}
    >
      <VStack alignItems={'center'} justifyContent={'center'}>
        {buttonIcon}

        <Text color={isSelected ? primary400 : 'white'} fontWeight={'normal'}>
          {location}
        </Text>
      </VStack>
    </Wrapper>
  );
};
